<template>
    <div>
        <v-dialog width="900" v-model="dialog">
            <template v-slot:activator="{ on }">

                <v-btn depressed small v-on="on">
                    {{ newList.surname }} {{ newList.name }}
                    {{ newList.patronymic }}

                    <v-icon color="blue" small right> mdi-open-in-new </v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Абитуриент</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form class="px-3 mt-5">
                        <v-text-field
                            disabled
                            label="ID"
                            v-model="newList.enrolleeId"
                        >
                        </v-text-field>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="Фамилия"
                                    v-model="newList.surname"
                                >
                                </v-text-field>
                                <v-text-field
                                    label="Имя"
                                    v-model="newList.name"
                                >
                                </v-text-field>
                                <v-text-field
                                    label="Отчество"
                                    v-model="newList.patronymic"
                                >
                                </v-text-field>
                                <v-text-field
                                    v-mask="'##.##.####'"
                                    label="Дата рождения"
                                    v-model="newList.birth"
                                >
                                </v-text-field>
                                <v-text-field
                                    label="СНИЛС"
                                    v-model="newList.snils"
                                    v-mask="'###-###-### ##'"
                                >
                                </v-text-field>
                                <v-text-field
                                    label="Школа обучения"
                                    v-model="newList.currentSchool"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="Первый родитель"
                                    v-model="newList.parent"
                                >
                                </v-text-field>
                                <v-text-field
                                    v-mask="'#(###)###-##-##'"
                                    label="Телефон"
                                    v-model="newList.phone"
                                >
                                </v-text-field>
                                <v-text-field
                                    label="Почта"
                                    v-model="newList.email"
                                >
                                </v-text-field>
                                <v-text-field
                                    label="Второй родитель"
                                    v-model="newList.parentSecond"
                                >
                                </v-text-field>
                                <v-text-field
                                    v-mask="'#(###)###-##-##'"
                                    label="Телефон"
                                    v-model="newList.phoneSecond"
                                >
                                </v-text-field>
                                <v-text-field
                                    disabled
                                    label="Резервный"
                                    v-model="newList.reservedList"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-text-field
                            label="Предыдущий личный номер абитуриента"
                            v-model="newList.prevId"
                        >
                        </v-text-field>
                        <v-expansion-panels class="mb-3">
                            <v-expansion-panel>
                                <v-expansion-panel-header>Очередь</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div class="radioGroup">
                                        <v-radio-group
                                            v-model="reservedList"
                                            row
                                            @change="changeList(this)"
                                        >
                                            <v-radio
                                                label="Основа"
                                                v-bind:value='false'
                                            ></v-radio>
                                            <v-radio
                                                label="Резерв"
                                                v-bind:value='true'
                                            ></v-radio>
                                            <confirm-dialogue
                                                ref="confirmDialogue"
                                            ></confirm-dialogue>
                                        </v-radio-group>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Статус</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                <div class="radioGroup">
                            <v-radio-group
                                v-model="status"
                                row
                                @change="changeStatus(this)"
                            >
                                <v-radio
                                    label="Создан"
                                    value="created"
                                ></v-radio>
                                <v-radio
                                    label="Необходимо подтвердить"
                                    value="confirmation-process"
                                ></v-radio>
                                <v-radio
                                    label="Подтвержден"
                                    value="confirmed"
                                ></v-radio>
                                <v-radio
                                    label="Приглашен"
                                    value="invited"
                                ></v-radio>
                                <v-radio
                                    disabled
                                    label="Удален"
                                    value="deleted"
                                ></v-radio>
                            </v-radio-group>
                        </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    Письма
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card-actions class="d-flex justify-space-between px-5">
                            <v-btn small @click="sendMail('registration')"
                                >
                                Регистрация в основу</v-btn
                            >
                            <confirm-dialogue
                                ref="confirmDialogue"
                            ></confirm-dialogue>
                            <v-btn small @click="sendMail('registrationReserve')"
                                >Регистрация в резервный список</v-btn
                            >
                            <v-btn small @click="sendMail('confirmation')"
                                >Подтверждение</v-btn
                            >
                            
                            
                        </v-card-actions>
                        <v-card-actions class="d-flex justify-space-between px-5">
                            <v-btn small @click="sendMail('confirmed')"
                                >После прохождения подтверждения</v-btn
                            >
                            
                            <v-btn small @click="sendMail('confirmationSecond')"
                                >Напоминание подтверждения</v-btn
                            >
                            <v-btn small @click="sendMail('removedNonconfirmed')"
                                >Удаление из-за отсутсвия подтверждения</v-btn
                            >
                        </v-card-actions>
                        <v-card-actions class="d-flex justify-space-between px-5">
                            <v-btn small @click="sendMail('notVisited')"
                                >Про отсутствие на вступительном испытании</v-btn
                            >
                            <v-btn small @click="sendMail('reserveToMain')"
                                >Перенос из резервного списка в основной</v-btn
                            >
                            <v-btn small @click="sendMail('invitation')"
                                >Приглашение</v-btn
                            >
                            
                        </v-card-actions>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <v-card-actions class="flex px-5 justify-space-between"
                            ><v-btn
                                text
                                class="success mx-0 mt-3"
                                @click="saveEnrolee"
                                >Сохранить</v-btn
                            >
                            <v-btn text class="mx-0 mt-3" @click="exportPDF"
                                >PDF</v-btn
                            >
                            <confirm-dialogue
                                ref="confirmDialogue"
                            ></confirm-dialogue>
                            <v-btn
                                text
                                class="error mx-0 mt-3"
                                @click="deleteEnrollee"
                                >Удалить</v-btn
                            ></v-card-actions
                        >
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios'
import ConfirmDialogue from '../helpers/ConfirmDialogue.vue'
export default {
    components: {
        ConfirmDialogue
    },
    data() {
        return {
            dialog: false,
            dataElement: {},
            status: this.element.status,
            reservedList: this.element.reservedList
        }
    },
    props: {
        element: {
            type: Object,
            default() {
                return {}
            },
        },
        updateEnrolleeList: {
            type: Function
        }
    },
    computed: {
        listBoolToString: function () {
            console.log(this.reservedList);
        },
        newList: function () {
            return (this.dataElement = Object.assign(
                this.dataElement,
                this.element
            ))
        },
    },
    methods: {
        async changeList() {
            const answer = await axios.post('/api/changeList', {
            enrolleeId: this.element.enrolleeId,
            reservedList: this.reservedList
            })
            if (answer.data.answer == 'success') {
                this.$notify({
                    text: answer.data.text
                });
            } else {
                this.$notify({
                    type: 'error',
                    text: answer.data.text
                });
            }
        },
        changeStatus() {
            axios.post('/api/changeEnrolleeStatus', {
                enrolleeId: this.element.enrolleeId,
                status: this.status,
            }).then((answer) => {
                if(answer.data.success) {
                    this.$notify({
                        type: 'default',
                        text: answer.data.text
                    });
                } else {
                    this.$notify({
                        type: 'default',
                        text: 'Произошла ошибка'
                    });
                }
            })
        },
        async sendMail(type) {
            const ok = await this.$refs.confirmDialogue.show({
                message: 'Вы уверены, что хотите отправить письмо?',
                okButton: 'Отправить',
            })
            if (ok) {
                this.dataElement.type = type
                axios.post('/api/send-mail', this.dataElement).then((data) => {
                    this.$notify({
                        type: 'default',
                        text: data.data.msg
                    });
                })
            }

        },
        exportPDF() {
            this.$axios
                .post('/pdf', this.dataElement, { responseType: 'arraybuffer' })
                .then((data) => {
                    console.log(data);
                    var fileURL = window.URL.createObjectURL(
                        new Blob([data.data], {
                            type: 'application/pdf',
                        })
                    )
                    window.open(fileURL)
                })
        },
        saveEnrolee() {
            const newEnrollee = { ...this.dataElement }
            delete newEnrollee.reservedList
            delete newEnrollee.status
            this.$axios
                .post('/api/edit-enrollee/', newEnrollee)
                .then((res) => {
                    if (res.data.status === 'success') {
                        this.dialog = false
                        this.$notify({
                            type: 'default',
                            text: 'Успешно сохранено'
                        });
                        this.$emit('changesSaved', this.newList)
                        this.updateEnrolleeList(this.dataElement)
                    }
                })
        },
        async deleteEnrollee() {
            const ok = await this.$refs.confirmDialogue.show({
                message: 'Вы уверены, что хотите удалить запись?',
                okButton: 'Удалить',
            })
            console.log(this.dataElement)
            if (ok) {
                axios.post('/api/delete-enrollee', this.dataElement).then((res) => {
                    if (res.data.status == 'success') {
                        this.$notify({
                            type: 'default',
                            text: res.data.msg
                        });
                        this.dialog = false
                        const newEnrol = {...this.dataElement, status:'deleted', comment:'Удален', snils: '000-000-000 00'}
                        this.updateEnrolleeList(newEnrol)
                    }
                })
            }
        },
    },
    validations: {
        /*     snils: {
      required,
      snilsVal: (val) => /^\d{3}-\d{3}-\d{3} \d{2}$/i.test(val),
    },
    birth: {
      required,
      birthVal: (val) =>
        /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/i.test(
          val
        ),
    },
    phone: {
      required,
      phoneVal: (val) => /^(8-?|\+?7-?)?(\(?\d{3}\)?)-?(\d-?){6}\d$/i.test(val),
    }, */
    },
}
</script>
<style scoped>
.radioGroup {
    display: flex;
    justify-content: center;
}
</style>